import {
  BlockColorsItem,
  DragHandleMenu,
  RemoveBlockItem,
  SideMenu as BlockNoteSideMenu,
  TableColumnHeaderItem,
  TableRowHeaderItem,
  useDictionary,
} from '@blocknote/react'
import type { ComponentProps } from 'react'
import TurnIntoMenuItem from './TurnIntoMenuItem'

type SideMenuProps = ComponentProps<typeof BlockNoteSideMenu>

const WorkspaceDragHandleMenu = () => {
  const dict = useDictionary()

  return (
    <DragHandleMenu>
      <TurnIntoMenuItem>Turn into</TurnIntoMenuItem>
      <BlockColorsItem>{dict.drag_handle.colors_menuitem}</BlockColorsItem>
      <RemoveBlockItem>{dict.drag_handle.delete_menuitem}</RemoveBlockItem>
      <TableRowHeaderItem>{dict.drag_handle.header_row_menuitem}</TableRowHeaderItem>
      <TableColumnHeaderItem>{dict.drag_handle.header_column_menuitem}</TableColumnHeaderItem>
    </DragHandleMenu>
  )
}

const WorkspaceSideMenu = (props: SideMenuProps) => (
  <BlockNoteSideMenu {...props} dragHandleMenu={WorkspaceDragHandleMenu} />
)

export default WorkspaceSideMenu
